// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as DataflowADefault } from '../../../assets/icons/default/development/dataflow-a.svg?react';
import { ReactComponent as DataflowASolid } from '../../../assets/icons/solid/development/DATAFLOW-A.svg?react';
import { createIcons } from '../../Icon';
const DataflowAIcon = /* @__PURE__ */ createIcons('DataflowA', {
    default: DataflowADefault,
    solid: DataflowASolid
});
DataflowAIcon.supportedTypes = ['default', 'solid'];
DataflowAIcon.category = 'development';
export default DataflowAIcon;
